import React from 'react';

const PreLoadPalletTableComponentLoadable = React.lazy(() => import('./PreLoadPalletTableComponent'));
// const  PalletDetailComponentLoadable = React.lazy(() => import('./PalletDetailComponent'));
export {
    // PalletDetailComponentLoadable,
    PreLoadPalletTableComponentLoadable
}